import React from "react";
import { BackButton, BackIcon, BackSpan } from "../../SelectClient/styles";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useEffect } from "react";
import { FormattedMessage } from "react-intl";

export default function GoBackButton({
  href,
  intlId = "goback",
  noPosition = false,
  clearStorage,
}) {
  const history = useHistory();

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        history.push(href);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [history, href]);

  return (
    <BackButton
      onClick={() => {
        if (clearStorage) {
          sessionStorage.removeItem("StaffJourneyAccessed");
        }
      }}
      to={href}
      noPosition={noPosition}
    >
      <BackIcon>
        <ArrowBack />
      </BackIcon>
      <BackSpan>
        <FormattedMessage id={intlId} />
        <span> (Esc)</span>
      </BackSpan>{" "}
    </BackButton>
  );
}

const ArrowBack = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 21"
  >
    <path
      stroke="#62748E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M3 10.5h14M8 14.667 3 10.5l5-4.167"
    ></path>
  </svg>
);
